import { z } from "zod";

export const assignRoleSchema = z.object({
  level: z.string().min(1, "Level is required"),
  name: z.string().min(1, "Name is required"),
  role: z.string().min(1, "Role is required"),
});

export type AssignRoleType = z.infer<typeof assignRoleSchema>;

export const editRoleSchema = z.object({
  level: z.string().min(1, "Level is required"),
  roleId: z.string().min(1, "Role is required"),
  entityId: z.string().optional(),
});

export type EditRoleType = z.infer<typeof editRoleSchema>;
